<template>
  <div class="row">
    <div class="col-md-12">
      <div class="row">
        <div class="col-lg-10 mx-auto">
          <div class="row justify-content-center mb-4">
            <div class="col-md-6">
              <div class="col-auto">
                <div class="m-b-30">
                  <!-- {{formParamScrapeSt}}
                  {{formMPId}} -->
                  <!-- <hr />
                  {{selectedMPId}} -->
                         <!-- {{ formMPIdArr }} -->

                  <ul
                    :key="idx"
                    v-for="(marketplace,idx) in dataListMarketplace"
                    class="list-group notification-list"
                  >
                    <!-- <template v-if="dataListMarketplace.length"> -->
                    <li class="list-group-item">
                      <span v-html="marketplaceIcon(marketplace)"></span>
                      <!-- {{idx}} -->
                      <div class="status-toggle">
                        <!-- {{formInput[index]}} -->
                        <input
                          :ref="'mp_'+marketplace"
                          :id="'mp_'+marketplace"
                          v-model="formMPId[idx]"
                          type="checkbox"
                          class="check"
                          @change="updateOrDelete(marketplace,idx)"
                        />
                        <label :for="'mp_'+marketplace" class="checktoggle">checkbox</label>
                      </div>
                    </li>
                    <!-- </template> -->
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";

import { marketplaceIcon } from "@/utils/helper";
export default {
  components: {
    Skeleton
  },
  props: {
    activeIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      formMPIdArr:[],
      dataListMarketplace: [],
      formMPId: [],
      selectedMPId: [],
      isLoading: false
    };
  },
  watch: {
    formParamScrapeSt: {
      handler: async function(val, oldVal) {
        if (val != oldVal) {
          // console.log("oldValForm2", oldVal);
          // console.log("newValForm2", val);
          this.selectedMPId = val.mp_id;
          // this.formMPId = val.mp_id;
          // console.log("selectedMPId", this.selectedMPId);
          await this.getMarketplaceList();

          var that = this;

          await setTimeout(async function() {
            // console.log("that.dataListMarketplace", that.dataListMarketplace);

            if (that.selectedMPId.length > 0) {
              let selectedMPId = that.selectedMPId;
              // console.log("selectedMPIdx", selectedMPId);

              that.selectedMPId = [];
              that.formMPId = [];
              selectedMPId.forEach((value, idx) => {
                var index2 = that.dataListMarketplace.indexOf(value);
                // console.log("valuee select index2", index2, value);

                if (index2 !== -1) {
                  // this.selectedMPId.splice(index2, 1);
                  that.formMPId[index2] = true;
                  that.updateOrDelete(value, index2);
                  // console.log("valuee select", value);
                }
              });
            } else {
              that.formMPId = [];
            }
          }, 100);
        }
      },
      deep: true
    },
    selectedMPId: {
      handler: function(val, oldVal) {
        this.formValidate(val);
      },
      deep: true
    },
    formMPId: {
      handler: function(val, oldVal) {
        this.formValidate(val);
      },
      deep: true
    },
    activeIndex: {
      handler: function(val, oldVal) {
        // console.log("val", val, "oldVal", oldVal);
        if (val == true) {
          // console.log("active index")
          // this.selectedLicense = [];
          var that = this;
          setTimeout(function() {
            if (val == 1) {
              that.getMarketplaceList();
              if (that.selectedMPId.length > 0) {
                let selectedMPId = that.selectedMPId;
                that.selectedMPId = [];
                that.formMPId = [];
                selectedMPId.forEach((value, idx) => {
                  var index2 = that.dataListMarketplace.indexOf(value);
                  // console.log("valuee select index2", index2, value);

                  if (index2 !== -1) {
                    // this.selectedMPId.splice(index2, 1);
                    that.formMPId[index2] = true;
                    that.updateOrDelete(value, index2);
                    // console.log("valuee select", value);
                  }
                });
              } else {
                that.formMPId = [];
              }
            }
            // console.log("that.broadcastParamSt", that.broadcastParamSt);
            // that.formPar
            // that.asyncFindProduct();
            // console.log("")
          }, 100);
        }
      },
      deep: true
    }
  },
  computed: {
    formParamScrapeSt() {
      return this.$store.state.monitoring.formParamScrapeSt;
    }
  },
  filters: {
    capitalising: function(data) {
      var capitalized = [];
      data.split(" ").forEach(word => {
        capitalized.push(
          word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        );
      });
      return capitalized.join(" ");
    }
  },
  methods: {
    formValidate() {
      // let newParam = {
      //   mp_product_master_id: "",
      //   keywords_id: [],
      //   min_price: 0,
      //   max_price: 0,
      //   sort_by: "price",
      //   order_by: "asc",
      //   mp_id: [],
      //   sending_options: 1,
      //   sending_schedule: "",
      //   is_recurring: 0,
      //   recurring_form: {
      //     recurrence: "",
      //     recurrence_time: "00:01",
      //     recurrence_every: "",
      //     recurrence_annually_month: "",
      //     recurrence_end: "never",
      //     recurrence_end_date: ""
      //   }
      // };

      let newParam = this.formParamScrapeSt;
      
      // newParam.mp_id = this.selectedMPId;
      newParam.mp_id = this.formMPIdArr;

      this.$store.dispatch("monitoring/actFormParamScrapeSt", newParam);
      // console.log("newParamForm2", newParam);
    },
    spliceMultidimensionalByKey(arr, keyToMatch, valueToMatch) {
      for (let i = 0; i < arr.length; i++) {
        // Assuming each sub-array is an object or an array of objects
        // If it's an array of objects:
        if (Array.isArray(arr[i])) {
          for (let j = 0; j < arr[i].length; j++) {
            if (arr[i][j] && arr[i][j][keyToMatch] === valueToMatch) {
              arr[i].splice(j, 1); // Remove 1 element at index j
              return true; // Element found and removed
            }
          }
        } 
        // If it's an object directly within the main array:
        else if (arr[i] && arr[i][keyToMatch] === valueToMatch) {
          arr.splice(i, 1); // Remove 1 element at index i
          return true; // Element found and removed
        }
      }
      return false; // Element not found
    },
    async updateOrDelete(value, index) {
      this.isLoading = true;
      const valueStr = value.toString();

      if (this.formMPId[index] === true) {
        // ✅ Tambahkan hanya jika belum ada
        if (!this.formMPIdArr.some(item => item.id === valueStr)) {
          this.formMPIdArr.push({ id: valueStr, is_selected: true });
        }

        // Pastikan selectedMPId juga unik
        if (!this.selectedMPId.includes(valueStr)) {
          this.selectedMPId.push(valueStr);
        }

      } else {
        console.log("false", value);

        // Hapus dari selectedMPId
        const index2 = this.selectedMPId.indexOf(valueStr);
        if (index2 !== -1) {
          this.selectedMPId.splice(index2, 1);
        }

        // Hapus dari formMPIdArr berdasarkan id
        this.formMPIdArr = this.formMPIdArr.filter(item => item.id !== valueStr);

        // Jika sudah tidak ada yang dipilih, reset semua
        if (this.selectedMPId.length < 1) {
          this.formMPId = [];
          this.formMPIdArr = [];
        }
      }

      this.isLoading = false;
    },
    marketplaceIcon(value) {
      return marketplaceIcon(value);
    },
    getMarketplaceList() {
      this.isLoading = true;
      this.$store
        .dispatch("monitoring/getMarketplaceList")
        .then(response => {
          this.isLoading = false;
          this.dataListMarketplace = response.data;
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
    }
  },
  async created() {},
  beforeDestroy() {},
  mounted() {
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "buttons-add"
};
</script>


// WEBPACK FOOTER //
// src/views/monitoring/scrape/components/form2.vue